/**
 * @flow
 */

import { SESSION_FETCH_SUCCESS } from '../session/actions';
import {
  UPDATE_INVOICE_FIELD,
  GENERATE_INVOICE_SUCCESS
} from './actions';

const initialState = {
  taxNumber: '',
  fullName: '',
  company: '',
  address: '',
  city: '',
  stateProvince: '',
  country: '',
  zipPostal: '',
  created: false,
  id: null
};

export default (state: AnyMap = initialState, action: Object): AnyMap => {
  switch (action.type) {
    case GENERATE_INVOICE_SUCCESS:
      return Object.assign({}, state, {
        created: true,
        id: action.payload.invoice.id
      });

    case SESSION_FETCH_SUCCESS:
      return Object.assign({}, state, {
        fullName: `${action.payload.user.first_name} ${action.payload.user.last_name}`
      });

    case UPDATE_INVOICE_FIELD:
      if (action.payload.input === 'taxNumber') {
        return Object.assign({}, state, {
          taxNumber: action.payload.value
        });
      }
      else if (action.payload.input === 'fullName') {
        return Object.assign({}, state, {
          fullName: action.payload.value
        });
      }
      else if (action.payload.input === 'company') {
        return Object.assign({}, state, {
          company: action.payload.value
        });
      }
      else if (action.payload.input === 'address') {
        return Object.assign({}, state, {
          address: action.payload.value
        });
      }
      else if (action.payload.input === 'city') {
        return Object.assign({}, state, {
          city: action.payload.value
        });
      }
      else if (action.payload.input === 'stateProvince') {
        return Object.assign({}, state, {
          stateProvince: action.payload.value
        });
      }
      else if (action.payload.input === 'country') {
        return Object.assign({}, state, {
          country: action.payload.value
        });
      }
      else if (action.payload.input === 'zipPostal') {
        return Object.assign({}, state, {
          zipPostal: action.payload.value
        });
      }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/invoice/reducer.js